export default {
  steps: [
    {
      title: 'Informações básicas',
      icon: 'FileTextIcon',
      completed: false,
      current: true,
      path: 'step-basic-info',
      order: 0,
    },
    {
      title: 'Endereço',
      icon: 'PhoneIcon',
      completed: false,
      current: false,
      path: 'step-address',
      order: 1,
    },
    {
      title: 'Diversidade e inclusão',
      icon: 'UsersIcon',
      completed: false,
      current: false,
      path: 'step-diversity',
      order: 2,
    },
    {
      title: 'Formação',
      icon: 'BookIcon',
      completed: false,
      current: false,
      path: 'step-formation',
      order: 3,
    },
    {
      title: 'Experiências',
      icon: 'AwardIcon',
      completed: false,
      current: false,
      path: 'step-experiences',
      order: 4,
    },
    {
      title: 'Idiomas',
      icon: 'MessageSquareIcon',
      completed: false,
      current: false,
      path: 'step-languages',
      order: 5,
    },
    {
      title: 'Habilidades',
      icon: 'StarIcon',
      completed: false,
      current: false,
      path: 'step-skills',
      order: 6,
    },
    {
      title: "Programa de indicação",
      icon: "GiftIcon",
      completed: false,
      current: false,
      path: "step-referral-program",
      order: 7,
    },
    {
      title: 'Perguntas Complementares',
      icon: 'LampIcon',
      completed: false,
      current: false,
      path: 'step-complementary-questions',
      order: 8,
    },
    {
      title: "Revisão",
      icon: "ThumbsUpIcon",
      completed: false,
      current: false,
      path: "step-revision",
      order: 9,
    }
  ],
  currentStep: 0,
  secondStep: 0,
  step: {
    progress: 10
  },
  basicFormSubmit: { trigger: false, goTo: undefined },
}